import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import type { RootState } from "../../app/store"

interface BeErrorState {
  hasError: boolean | null
}

const initialState: BeErrorState = {
  hasError: false,
}

export const beErrorSlice = createSlice({
  name: "beError",
  initialState,
  reducers: {
    setBeError: (state, action: PayloadAction<boolean>) => {
      state.hasError = action.payload
    },
  },
})

export const { setBeError } = beErrorSlice.actions
export const selectBeError = (state: RootState) => state.beError.hasError
export default beErrorSlice.reducer
